import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { accountApi } from '../../api/account';
import 'styles/ForgotPassword.scss';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      // Call your API here
      const response = await accountApi.requestPasswordReset({ email });
      // await forgotPasswordService(email);
      if (response?.data?.token) {
      // ✅ redirect to reset password page with token
      navigate(`/resetPassword?token=${response.data.token}`);
    } else {
       // ❌ email not found (or no token generated)
      setError(response?.data?.message || "Email not found.");
    }
  } catch (err) {
    setError("Something went wrong. Try again!");
  } finally {
    setLoading(false);
  }
  };

  return (
    <div className="forgotPassword-container">
      {/* Background blur */}
      <div className="forgotPassword-blur-bg">
        <div className="forgotPassword-blur purple-blur"></div>
        <div className="forgotPassword-blur pink-blur"></div>
        <div className="forgotPassword-blur purple-blur-2"></div>
      </div>

      {/* Content */}
      <div className="forgotPassword-content">
        <div className="forgotPassword-left">
          <div className="forgotPassword-brand">
            <div className="brand-text-container">
              <div className="brand-main">
                <span className="brand-axel">Axel</span>
                <span className="brand-marketplace">Marketplace</span>
              </div>
        
            </div>
          </div>

          <div className="forgotPassword-subtitle">
            <h2>Forgot Password?</h2>
            <p>Enter your email to receive a reset link</p>
          </div>

          <form className={`forgotPassword-form ${loading ? "form-loading" : ""}`} onSubmit={handleSubmit}>
            {error && <div className="general-error">{error}</div>}

            <div className="form-group">
              <input
                type="email"
                placeholder="Enter your email"
                className="forgotPassword-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <button type="submit" className="forgotPassword-btn" disabled={loading} >
              {loading ? "Sending..." : "Send Reset Link"}
            </button>

            <div className="login-link">
              <button
                type="button"
                className="login-back-btn"
                onClick={() => navigate("/login")}
              >
                Back to Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
